module.exports = __webpack_public_path__ + "img/groupInvitation.3a28011e.svg";